import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Misunderstanding Division',
		description:
			'Hire diplomats who specialize in creating international misunderstandings.'
	},
	{
		name: 'Wrong Translation Service',
		description:
			'Translate everything through 20 different languages before delivery.'
	},
	{
		name: 'Interpretive Dance Policy',
		description:
			'Replace all diplomatic communications with interpretive dance performances.'
	},
	{
		name: 'Quantum Negotiations',
		description:
			'All diplomatic agreements exist in multiple states until observed.'
	},
	{
		name: 'Time-Traveling Treaties',
		description:
			'Sign agreements that become valid in the past. Paradoxes guaranteed!'
	},
	{
		name: 'Multiverse Relations',
		description:
			'Establish diplomatic relations with every parallel universe simultaneously.'
	},
	{
		name: 'Void Diplomacy',
		description:
			'Negotiate directly with the void. Very efficient, slightly existential.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Diplomacy Syndicate'],
	departments[DepartmentIds['Diplomacy Syndicate']].basePrice * 3,
	UpgradeIds.DysExponent1
)

export default array
